export var defaultSharingImage = '/images/default_share.jpg';